import {useTranslation} from "react-i18next";
import {Button} from "antd";
import {VerticalAlignBottomOutlined} from "@ant-design/icons";
import {DOWNLOAD_FILE} from "@/utils/http.ts";

export const DownloadFileButton = (
    {
        disabled,
        url,
        fileName
    }: {
        disabled?: boolean,
        url?: string,
        fileName?: string,
    }
) => {
    const {t} = useTranslation();

    return (
        <Button
            type={'primary'}
            iconPosition={'end'}
            icon={<VerticalAlignBottomOutlined/>}
            disabled={disabled}
            onClick={() => {
                if (url) {
                    DOWNLOAD_FILE(url, fileName || "noname").then()
                }
            }}
        >
            {t('button.download')}
        </Button>
    )
}